import { SettingsGroup } from '@elipssolution/harfang';
import { CircularProgress, Typography, styled } from '@mui/material';

import InternalUserPermission from './InternalUserPermission';
import modulesConfig from '../../../../modules/modules';
import { PermissionModuleType, UserPermissionType } from '../../../types/permission';

const LoaderWrapper = styled('div')(({ theme: { spacing, palette } }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	gap: spacing(1),
	marginTop: spacing(1),

	'& svg': {
		color: palette.grey[400],
	},
}));

type InternalUserPermissionModulesProps = {
	disabled: boolean;
	loading?: boolean;
	permissionModules: PermissionModuleType<UserPermissionType>[];
	onPermissionChanged: () => void;
};

const InternalUserPermissionModules = ({
	disabled,
	loading = false,
	permissionModules,
	onPermissionChanged,
}: InternalUserPermissionModulesProps) =>
	loading ? (
		<LoaderWrapper>
			<Typography>Chargement des droits de l&apos;utilisateur en cours...</Typography>
			<CircularProgress size="24px" color="inherit" />
		</LoaderWrapper>
	) : (
		<>
			{permissionModules.map(({ code, id, permissions }) => {
				const moduleName = modulesConfig.find((module) => module.code === code)?.name;

				return (
					<SettingsGroup key={id} label={code === 'general' ? 'Général' : moduleName} actionsWidth={180}>
						{permissions.map((permission: UserPermissionType) => (
							<InternalUserPermission
								key={permission.id}
								disabled={disabled}
								permission={permission}
								onPermissionChanged={onPermissionChanged}
							/>
						))}
					</SettingsGroup>
				);
			})}
		</>
	);

export default InternalUserPermissionModules;
